import { useEffect, useState } from "react";

import { api } from "../../api/client";
import { AdminPageIntro } from "../../components/admin/AdminPageIntro";
import { AlertBanner } from "../../components/feedback/AlertBanner";
import { ResponsiveTable } from "../../components/ui/ResponsiveTable";
import { apiError } from "../../lib/apiError";
import { formatDateTime } from "../../lib/format";

type PendingDeletion = {
  user_id: number;
  user_email: string;
  kind: string;
  requested_at: string;
  purge_at: string;
};

export function AdminDeletionsPage() {
  const [deletions, setDeletions] = useState<PendingDeletion[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const result = await api.GET("/api/platform/pending-deletions");
      if (cancelled) {
        return;
      }
      if (result.error) {
        setError(apiError(result.error, "Nie udało się wczytać kolejki usunięć."));
        return;
      }
      const data = result.data as { deletions: PendingDeletion[] };
      setDeletions(data.deletions);
    }

    void load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page__content page__content--admin">
      <AdminPageIntro>Konta zaplanowane do trwałego usunięcia.</AdminPageIntro>

      {error ? (
        <AlertBanner variant="error" message={error} onDismiss={() => setError(null)} />
      ) : null}

      {deletions.length === 0 ? (
        <p className="muted">Brak zaplanowanych usunięć.</p>
      ) : (
        <div className="tbl-wrap">
          <ResponsiveTable className="tbl">
            <thead>
              <tr>
                <th>ID</th>
                <th>E-mail</th>
                <th>Typ</th>
                <th>Zgłoszono</th>
                <th>Usunięcie</th>
              </tr>
            </thead>
            <tbody>
              {deletions.map((item) => (
                <tr key={`${item.user_id}-${item.kind}`}>
                  <td>{item.user_id}</td>
                  <td>{item.user_email}</td>
                  <td>{item.kind}</td>
                  <td>{formatDateTime(item.requested_at)}</td>
                  <td>{formatDateTime(item.purge_at)}</td>
                </tr>
              ))}
            </tbody>
          </ResponsiveTable>
        </div>
      )}
    </div>
  );
}
